import React from 'react';
import PropTypes from 'prop-types';
import Card from 'common/components/card';
import CardHeader from 'common/components/card-header';
import CardContent from 'common/components/card-content';
import SvgSymbol from 'common/components/svg-symbol';
import {t} from 'common/utils/translation-util';
import './index.scss';

export default class GhostCard extends React.Component {
  static propTypes = {
    subtitle: PropTypes.string,
    title: PropTypes.string,
  };

  static defaultProps = {
    subtitle: '',
    title: '',
  };

  render() {
    return (
      <Card className={'GhostCard'}>
        {this.props.title || this.props.subtitle ? (
          <CardHeader subtitle={this.props.subtitle} title={this.props.title} />
        ) : null}
        <CardContent>
          <SvgSymbol className={'drag-drop'} name={'drag-drop'} />
          <span className={'GhostCard-caption'}>{t('Drag and drop')}</span>
        </CardContent>
      </Card>
    );
  }
}
